import { keyBy, mapValues } from "lodash";
import { callAppAPI } from "./AppApiClient";
import { DictionnaireApi } from "./DictionnaireApi";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import { VerificationTelephone } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/useValidationSchemaTelephone";
import { Configuration } from "src/domain/Configuration";
import { EmailCheckResponse } from "src/domain/EmailCheckResponse";




export const fetchCGU = (): Promise<string> => {
  const url = DictionnaireApi.cgu.getUrl();
  return callAppAPI<string>({
    method: "GET",
    url: url,
  })
  .then(result => {
    return result;
  });
}

export const fetchTraductions = async (locale: string) => {
  const url = DictionnaireApi.labels.getUrl(locale);
  return callAppAPI<{ key: string; value: string }[]>({ method: "GET", url })
    .then((values) => {
      const result = keyBy(values, (val) => val.key);

      return mapValues(result, (o) => o.value);
    });
};

export const sendCodeMail = async (values: VerificationMail, langue: string) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.sendCodeMail.getUrl(),
    data: { ...values, locale: langue },
  });
};

export const sendCodeTelephone = async (values: VerificationTelephone, langue: string) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.sendCodeTelephone.getUrl(),
    data: { ...values, locale: langue },
  });
};

export const fetchConfiguration = (agence?: string | undefined): Promise<Configuration> => {
  const url = DictionnaireApi.configuration.getUrl(agence);
  return callAppAPI<Configuration>({
    method: "GET",
    url: url,
  })
    .then(result => {
      return result;
    });
}

export const checkEmail = async (email: string) => {
  return callAppAPI<EmailCheckResponse>({
    method: "POST",
    url: DictionnaireApi.checkEmail.getUrl(),
    data: { email },
  });
};
